<expandable-targeting-header [expanded]="true" [targeting]="targeting">
  @if(tracking) {
      <targeting-outcome-summary
        [viewCurrency]="targeting.view_currency"
        [pauseTargeting]="pauseTargeting"
        [tracking]="tracking">
      </targeting-outcome-summary>
      <div class="divider margin-top-bottom--2x"></div>
      <div>
        @if(deviceData?.length) {
          <tracking-distribution
            [distributions]="deviceDistribution"
            heading="Fördelning per apparat"
            [viewCurrency]="viewCurrency"
          ></tracking-distribution>
        }
        @if(regionDistribution?.length) {
          <tracking-distribution
            [distributions]="regionDistribution"
            heading="Fördelning per region"
            [viewCurrency]="viewCurrency"
          ></tracking-distribution>
        }
        @if(categoryDistribution?.length) {
          <tracking-distribution
            [distributions]="categoryDistribution"
            heading="Fördelning per kategori"
            [infoText]="hasTVKanalerCategory ? 'Utfall för styrningen TV-Kanaler grupperas och fördelas ut på våra olika genrekategorier. Utfall som ej tillhör någon av dessa kategorier hamnar istället under vår tv-kanaluppdelning som ni finner under rubriken TV-kanaler.' : null"
            [viewCurrency]="viewCurrency"
          ></tracking-distribution>
        }
        @if(programDistribution?.length) {
          <tracking-distribution
            [distributions]="programDistribution"
            heading="Fördelning per programformat"
            [viewCurrency]="viewCurrency"
          ></tracking-distribution>
        }
        @if(channelDistribution?.length) {
          <tracking-distribution
            [distributions]="channelDistribution"
            heading="Fördelning per TV-kanal"
            infoText="Här visas utfall för TV-Kanaler som ej tillhör någon av våra genrekategorier. 
            Utfall som tillhör en genrekategori finner du under rubriken Kategorier."
            [viewCurrency]="viewCurrency"
          ></tracking-distribution>
        }
        @if(dailyData?.length) {
          <div class="margin-top--3x">
            <expandable-header
              text="Totalt {{ viewCurrency }} & click-through per dag"
              chevronColor="black"
            >
              <woo-table
                [headers]="dailyHeaders"
                [rows]="dailyData"
                wooCopyTableAsNumber
              ></woo-table>
            </expandable-header>
          </div>
        }
        @if(deviceData?.length) {
          <div class="margin-top--2x">
            <expandable-header text="Apparater" chevronColor="black">
              <woo-table
                [headers]="deviceHeaders"
                [rows]="deviceData"
                wooCopyTableAsNumber
              ></woo-table>
            </expandable-header>
          </div>
        }
        @if(regionData?.length) {
          <div class="margin-top--2x">
            <expandable-header text="Regioner" chevronColor="black">
              <woo-table
                [headers]="regionHeaders"
                [rows]="regionData"
                wooCopyTableAsNumber
              ></woo-table>
            </expandable-header>
          </div>
        }
        @if(categoryData?.length) {
          <div class="margin-top--2x">
            <expandable-header text="Kategorier" chevronColor="black">
              <woo-table
                [headers]="categoryHeaders"
                [rows]="categoryData"
                wooCopyTableAsNumber
              ></woo-table>
            </expandable-header>
          </div>
        }
        @if(programData?.length) {
          <div class="margin-top--2x">
            <expandable-header text="Program" chevronColor="black">
              <woo-table
                [headers]="programHeaders"
                [rows]="programData"
                wooCopyTableAsNumber
              ></woo-table>
            </expandable-header>
          </div>
        }
        @if(channelData?.length) {
          <div class="margin-top--2x">
            <expandable-header text="TV-kanaler" chevronColor="black">
              <woo-table
                [headers]="channelHeaders"
                [rows]="channelData"
                wooCopyTableAsNumber
              ></woo-table>
            </expandable-header>
          </div>
        }
        @if(publisherData?.length > 1) {
          <div class="margin-top--2x">
            <expandable-header text="Publicister" chevronColor="black">
              <woo-table
                [headers]="publisherHeaders"
                [rows]="publisherData"
                wooCopyTableAsNumber
              ></woo-table>
            </expandable-header>
          </div>
        }
      </div>
  } @else {
    <h4>Ingen data tillgänglig</h4>
  }
</expandable-targeting-header>
